import { currencyNoDecimal } from "client/v3/components/Currency";
import React, { createContext, useContext, useState } from "react";

export const defaultDownPayment = 15000;

export const termsFormatted = '36 months';
export const annualMiles = '12,000 miles';
export const destinationFee = 3000;
export const destinationFeeFormatted = '$3,000';
export const acquisitionFeeFormatted = '$1,495';
export const depositFeeFormatted = '$500';

let leaseOptions = [
  { downPayment: 15000, due: 21485, monthly: 4990 },
  { downPayment: 30000, due: 35889.80, monthly: 4394.80 },
  { downPayment: 45000, due: 50189.72, monthly: 3694.72 },
  { downPayment: 60000, due: 64484.49, monthly: 2989.49 },
] as Option[];

leaseOptions = leaseOptions.map((x) => ({
  ...x,
  downPaymentFormatted: currencyNoDecimal(x.downPayment),
  dueFormatted: currencyNoDecimal(x.due),
  monthlyFormatted: currencyNoDecimal(x.monthly),
}));

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const defaultOption = leaseOptions.find((x) => x.downPayment === defaultDownPayment)!;

const LeaseContext = createContext({} as LeaseContextType);

function LeaseContextProvider(props) {
  const [selectedOption, setSelectedOption] = useState(defaultOption);

  return (
    <LeaseContext.Provider value={{ selectedOption, setSelectedOption, leaseOptions }}>
      {props.children}
    </LeaseContext.Provider>
  );
}

function useLeaseContext() {
  return useContext(LeaseContext);
}

export { LeaseContext, LeaseContextProvider, useLeaseContext };

type Option = {
  downPayment: number;
  due: number;
  monthly: number;
  downPaymentFormatted: string;
  dueFormatted: string;
  monthlyFormatted: string;
};

export type LeaseContextType = {
  selectedOption: Option;
  setSelectedOption: React.Dispatch<React.SetStateAction<{
    downPayment: number;
    due: number;
    monthly: number;
  }>>;
  leaseOptions: Option[];
}
